import { YAxis, YAxisProps } from 'recharts';

type GraphYAxisProps = Omit<YAxisProps, 'label' | 'width'> & {
  position?: 'left' | 'right';
  label: string;
};

export const GraphYAxis = ({ position = 'left', label, ...rest }: GraphYAxisProps) => {
  if (position === 'left') {
    return (
      <YAxis
        {...(label
          ? {
              label: {
                angle: -90,
                position: 'insideLeft',
                textAnchor: 'middle',
                value: label,
              },
              width: 'auto',
            }
          : {})}
        {...rest}
      />
    );
  }

  return (
    <YAxis
      orientation="right"
      {...(label
        ? {
            label: {
              angle: 90,
              position: 'insideRight',
              textAnchor: 'middle',
              value: label,
            },
            width: 'auto',
          }
        : {})}
      {...rest}
    />
  );
};
